export default defineNuxtRouteMiddleware(async (to, from) => {
  
    const { $fetchUser } = useNuxtApp();
    await $fetchUser();
  
  });
  